
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { awesomeTheme, Pacman, Profile } from "mdx-deck-theme-awesomeness";
export const theme = awesomeTheme;
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Footer = makeShortcode("Footer");
const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header mdxType="Header">
      <Profile name="Pedro Filho" twitter="pedroapfilho" mdxType="Profile" />
    </Header>
    <Footer mdxType="Footer">
      <Pacman mdxType="Pacman" />
    </Footer>
    <h1>{`Node like it's 2022`}</h1>
    <hr></hr>
    <h1>{`Who am I?`}</h1>
    <hr></hr>
    <h1>{`Pedro Filho`}</h1>
    <h2>{`Software Engineer at Blockchain.com`}</h2>
    <hr></hr>
    <h1>{`Node used to be challenging and fun`}</h1>
    <h3>{`but now it's just fun 😄`}</h3>
    <hr></hr>
    <h2>{`We had to use multiple methods to iterate over an object`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`function getTotalScore(scores) {
  var total = 0;

  Object.keys(scores).forEach(function (key) {
    total += scores[key];
  });

  return total;
}
`}</code></pre>
    <hr></hr>
    <h2>{`Now we can do it with a for...in`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const getTotalScore = (scores) => {
  let total = 0;

  for (const score in scores) {
    total += scores[score];
  }

  return total;
};
`}</code></pre>
    <hr></hr>
    <h2>{`We had to concat strings to get a phrase with variables`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`var firstName = "Bob";

var lastName = "Smith";

var intro = "Hey, my name is" + " " + firstName + " " + lastName;
`}</code></pre>
    <hr></hr>
    <h2>{`Now we can just use template literals`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const firstName = "Bob";

const lastName = "Smith";

const name = \`Hey, my name is \${firstName} \${lastName}\`;
`}</code></pre>
    <hr></hr>
    <h2>{`We had to use the hack to stringify and parse objects to clone them`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const a = { b: "something" };

const b = JSON.parse(JSON.stringify(a));
`}</code></pre>
    <hr></hr>
    <h2>{`Now, we just need to create a structuredClone`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const a = { b: "something" };

const b = structuredClone(a);
`}</code></pre>
    <hr></hr>
    <h2>{`What about default parameters?`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`function(a, b) {
  a = a || 1;
  b = b || 2;

  return a + b;
}
`}</code></pre>
    <hr></hr>
    <h2>{`Now it's as simple as`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`function(a = 1, b = 2) {
  return a + b;
}
`}</code></pre>
    <hr></hr>
    <h2>{`And don't get me started on async await, arrow functions, const and let...`}</h2>
    <h2>{`...and the rest of the things that I don't remember now, but are important`}</h2>
    <hr></hr>
    <h2>{`So do a favor to everyone`}</h2>
    <h1>{`Write node like it's 2022`}</h1>
    <hr></hr>
    <h2>{`github.com/pedroapfilho`}</h2>
    <h2>{`twitter.com/pedroapfilho`}</h2>
    <hr></hr>
    <h1>{`That's all folks 👋`}</h1>
    <h2>{`Hit me up with some questions!`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;